import { z } from 'zod';

export const loginSchema = z.object({
  userID: z.string().min(1, 'User ID is required').min(3, 'User ID must be at least 3 characters'),
  pin1: z.string().regex(/^\d$/, 'Required'),
  pin2: z.string().regex(/^\d$/, 'Required'),
  pin3: z.string().regex(/^\d$/, 'Required'),
  pin4: z.string().regex(/^\d$/, 'Required'),
});
export type LoginFormValues = z.infer<typeof loginSchema>;
